document.addEventListener("DOMContentLoaded", function () {
  const imagesAndVideos = document.querySelectorAll(".how-works__image-wrapper");
  const videos = document.querySelectorAll(".how-works__image-wrapper video");
  const steps = document.querySelectorAll(".how-works__step");

  steps.forEach((step, index) => {
    step.addEventListener("click", function () {

      imagesAndVideos.forEach((el) => el.classList.remove("active"));
      videos.forEach(video => video.pause());

      if (imagesAndVideos[index]) {
        imagesAndVideos[index].classList.add("active");

        const video = imagesAndVideos[index].querySelector("video");
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      }
    });
  });

});
